// extracted by mini-css-extract-plugin
export default {"accordion":"Breakdown-module__accordion___Q5qg2","priceLineItem":"Breakdown-module__priceLineItem___raJn4","totalPriceFooter":"Breakdown-module__totalPriceFooter___MFxf2"};